module.exports = __webpack_public_path__ + "img/iso.09becf42.png";